(function (root, factory) {
  'use strict';
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.WobkeyEngine = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const DURATIONS = Object.freeze([15, 25, 30, 60]);
  const DEFAULT_PASSAGE = "Rainy days are made for good ideas. Find your rhythm with Rainy75 V2, shaped by two years of listening and fine tuning. A richer sound, a better feel; the switch is outside, the case opens with a quick release. Your dongle finally has a home; ModLab brings modular design to your desk. Some keyboards spend their lives in photos. This one belongs in the quiet before the house wakes, in a late night idea, in the sentence you almost did not write. Let it keep company with your open tabs, unfinished notes, and the things you make just because. Still here? We had a whole weather forecast planned, but you typed right through it. Your reward is one extremely small round of applause. Imagine it sounding like rain. Good keys. Very fast hands. Rainy days are made for good ideas. Find your rhythm with Rainy75 V2, shaped by two years of listening and fine tuning. A richer sound, a better feel; the switch is outside, the case opens with a quick release. Your dongle finally has a home; ModLab brings modular design to your desk. Some keyboards spend their lives in photos. This one belongs in the quiet before the house wakes, in a late night idea, in the sentence you almost did not write. Let it keep company with your open tabs, unfinished notes, and the things you make just because. Still here? We had a whole weather forecast planned, but you typed right through it. Your reward is one extremely small round of applause. Imagine it sounding like rain. Good keys. Very fast hands.";
  function hashPassage(passage) {
    let hash = 2166136261;
    for (let i = 0; i < passage.length; i++) hash = Math.imul(hash ^ passage.charCodeAt(i), 16777619);
    return 'fnv1a-' + (hash >>> 0).toString(16).padStart(8, '0');
  }
  function cleanPassage(value) {
    if (typeof value !== 'string') throw new TypeError('Passage must be text.');
    const text = value.replace(/\s+/g, ' ').trim();
    if (!text || text.length > 10000 || !/^[\x20-\x7e]+$/.test(text)) throw new TypeError('Use 1–10,000 English keyboard characters.');
    return text;
  }
  class TypingEngine {
    constructor(options = {}) {
      this.passage = cleanPassage(options.passage === undefined ? DEFAULT_PASSAGE : options.passage);
      this.duration = options.duration === undefined ? 25 : Number(options.duration);
      if (!DURATIONS.includes(this.duration)) throw new RangeError('Unsupported duration.');
      this.status = 'ready'; this.text = ''; this.startedAt = null; this.deadline = null;
      this.elapsedMs = 0; this.correctCharacters = 0; this.visibleErrors = 0;
      this.insertionAttempts = 0; this.correctAttempts = 0; this.errorCount = 0;
      this.correctedCount = 0; this.cancelReason = ''; this.lastNow = null;
    }
    _time(now) {
      if (!Number.isFinite(now) || now < 0) throw new TypeError('A finite monotonic time is required.');
      // A caller cannot move the clock backwards after starting a run.
      const value = this.lastNow === null ? now : Math.max(now, this.lastNow);
      this.lastNow = value;
      return value;
    }
    _advance(now) {
      now = this._time(now);
      if (this.status === 'running') {
        this.elapsedMs = Math.min(this.duration * 1000, now - this.startedAt);
        if (now >= this.deadline) { this.elapsedMs = this.duration * 1000; this.status = 'complete'; }
      }
      return now;
    }
    insert(character, now) {
      now = this._advance(now);
      if (!/^[\x20-\x7e]$/.test(character) || typeof character !== 'string' || !['ready', 'running'].includes(this.status)) return this.snapshot(now);
      if (this.status === 'ready') { this.status = 'running'; this.startedAt = now; this.deadline = now + this.duration * 1000; }
      const correct = character === this.passage[this.text.length];
      this.insertionAttempts++;
      if (correct) { this.correctAttempts++; this.correctCharacters++; }
      else { this.errorCount++; this.visibleErrors++; }
      this.text += character;
      if (this.text.length === this.passage.length) { this.elapsedMs = now - this.startedAt; this.status = 'complete'; }
      return this.snapshot(now);
    }
    backspace(now) {
      now = this._advance(now);
      if (this.status === 'running' && this.text.length) {
        const index = this.text.length - 1;
        if (this.text[index] === this.passage[index]) this.correctCharacters--;
        else { this.visibleErrors--; this.correctedCount++; }
        this.text = this.text.slice(0, -1);
      }
      return this.snapshot(now);
    }
    tick(now) { this._advance(now); return this.snapshot(now); }
    cancel(reason = 'Run cancelled.') {
      if (this.status === 'running') { this.status = 'cancelled'; this.cancelReason = String(reason).slice(0, 200); }
      return this.snapshot();
    }
    snapshot(now) {
      if (now !== undefined) this._advance(now);
      const minutes = this.elapsedMs / 60000;
      return {
        status: this.status, text: this.text, position: this.text.length, duration: this.duration,
        elapsedMs: this.elapsedMs, remainingMs: Math.max(0, this.duration * 1000 - this.elapsedMs),
        correctCharacters: this.correctCharacters, visibleErrors: this.visibleErrors,
        insertionAttempts: this.insertionAttempts, correctAttempts: this.correctAttempts,
        errorCount: this.errorCount, correctedCount: this.correctedCount,
        wpm: minutes > 0 ? Math.round((this.correctCharacters / 5 / minutes) * 10) / 10 : 0,
        accuracy: this.insertionAttempts ? Math.round(this.correctAttempts / this.insertionAttempts * 1000) / 10 : 100,
        cancelReason: this.cancelReason
      };
    }
  }
  function validateResult(input) {
    if (!input || typeof input !== 'object' || Array.isArray(input) || input.v !== 1) throw new TypeError('Unsupported result format.');
    const string = (key, max, pattern) => {
      if (typeof input[key] !== 'string' || input[key].length > max || (pattern && !pattern.test(input[key]))) throw new TypeError('Invalid result ' + key + '.');
      return input[key];
    };
    const number = (key, min, max, integer) => {
      const value = input[key];
      if (!Number.isFinite(value) || value < min || value > max || (integer && !Number.isInteger(value))) throw new TypeError('Invalid result ' + key + '.');
      return value;
    };
    const completedAt = string('completedAt', 24, /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/);
    if (!Number.isFinite(Date.parse(completedAt)) || new Date(completedAt).toISOString() !== completedAt) throw new TypeError('Invalid completion time.');
    const duration = number('duration', 15, 60, true);
    if (!DURATIONS.includes(duration)) throw new TypeError('Invalid duration.');
    const result = {
      v: 1,
      runId: string('runId', 36, /^[a-f0-9]{8}-[a-f0-9]{4}-4[a-f0-9]{3}-[89ab][a-f0-9]{3}-[a-f0-9]{12}$/i),
      passageId: string('passageId', 14, /^fnv1a-[a-f0-9]{8}$/),
      campaignTitle: string('campaignTitle', 80, /^[^\x00-\x1f\x7f]*$/),
      name: string('name', 40, /^[^\x00-\x1f\x7f]*$/),
      completedAt, duration,
      elapsedMs: number('elapsedMs', 1, duration * 1000, false),
      wpm: number('wpm', 0, 1000, false), accuracy: number('accuracy', 0, 100, false),
      correctCharacters: number('correctCharacters', 0, 10000, true),
      errorCount: number('errorCount', 0, 100000, true), correctedCount: number('correctedCount', 0, 100000, true)
    };
    if (result.correctedCount > result.errorCount) throw new TypeError('Invalid correction count.');
    const expected = Math.round((result.correctCharacters / 5 / (result.elapsedMs / 60000)) * 10) / 10;
    if (Math.abs(result.wpm - expected) > 0.11) throw new TypeError('Inconsistent speed.');
    return Object.freeze(result);
  }
  function createResult(snapshot, metadata) {
    if (snapshot.status !== 'complete') throw new TypeError('Only completed runs can be shared.');
    return validateResult({
      v: 1, runId: metadata.runId, passageId: hashPassage(cleanPassage(metadata.passage)),
      campaignTitle: metadata.campaignTitle || 'WOBKEY Typing Club', name: metadata.name || '',
      completedAt: metadata.completedAt, duration: snapshot.duration, elapsedMs: snapshot.elapsedMs,
      wpm: snapshot.wpm, accuracy: snapshot.accuracy, correctCharacters: snapshot.correctCharacters,
      errorCount: snapshot.errorCount, correctedCount: snapshot.correctedCount
    });
  }
  function encodeResult(input) {
    const json = JSON.stringify(validateResult(input));
    let base64;
    if (typeof Buffer !== 'undefined') base64 = Buffer.from(json, 'utf8').toString('base64');
    else {
      const bytes = new TextEncoder().encode(json);
      base64 = btoa(Array.from(bytes, byte => String.fromCharCode(byte)).join(''));
    }
    return base64.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
  }
  function decodeResult(payload) {
    if (typeof payload !== 'string' || payload.length > 4096 || !/^[A-Za-z0-9_-]+$/.test(payload) || payload.length % 4 === 1) throw new TypeError('Invalid result link.');
    let json;
    try {
      const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
      if (typeof Buffer !== 'undefined') json = Buffer.from(base64, 'base64').toString('utf8');
      else json = new TextDecoder('utf-8', { fatal: true }).decode(Uint8Array.from(atob(base64), char => char.charCodeAt(0)));
      return validateResult(JSON.parse(json));
    } catch (_) { throw new TypeError('This result link is invalid or unsupported.'); }
  }
  function formatTimestamp(iso) {
    const date = new Date(iso);
    if (!Number.isFinite(date.getTime())) return 'Invalid device time';
    const timeZone = 'America/New_York';
    const stamp = new Intl.DateTimeFormat('en-GB', { timeZone, year: 'numeric', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23' }).format(date);
    const zone = new Intl.DateTimeFormat('en-US', { timeZone, timeZoneName: 'short' }).formatToParts(date).find(part => part.type === 'timeZoneName').value;
    return stamp + ' (' + zone + ')';
  }
  return Object.freeze({ TypingEngine, hashPassage, cleanPassage, createResult, validateResult, encodeResult, decodeResult, formatTimestamp, DEFAULT_PASSAGE, DURATIONS });
});
